<template>
    <section class="video-home-banner">
        <div class="container-fluid">
            <div class="row row-banner">
                <div class="col-12 col-lg-7">
                    <h3 v-html='getMyLanguage("Home","search.cta")'></h3>
                    <p v-html='getMyLanguage("Home","search.cta.dne-token")'></p>
                </div>

                <div class="col-12 col-lg-5 col-img">
                    <img src="~@/assets/images/home/dne-market.png" alt="DNE Market">
                </div>
            </div>
        </div>

        <VideoHome />
    </section>
</template>

<script>
    import VideoHome from "@/components/Home/VideoHome.vue"

    import getMyContentLanguage from "@/services/contentLanguage.js"

    export default {
        components: {
            VideoHome,
        },

        data(){
            return {
                flagSelected: "en",
            }
        },

        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },

            getMyLanguage(group, code) {
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    @import '@/assets/scss/_colors.scss';
    
    .video-home-banner{
        position: relative;
        width: 100%;
        overflow: initial;
        margin-bottom: 0;
        display: flex;
        align-items: center;

        @media (max-width: 576px){
            height: 300px;
        }
        
        @media (min-width: 576px) and (max-width: 992px){
            height: 400px;
        }
        
        @media (min-width: 992px) and (max-width: 1600px){
            height: 500px;
        }

        @media (min-width: 1600px){
            height: 600px;
        }
        
        &:after{
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 10;
            top: 0;
            left: 0;

            @media (max-width: 992px){
                background: url('~@/assets/images/home/dne-market-white.png') no-repeat center rgba($color: $color-primary, $alpha: 0.85);
                background-size: auto 90%;
            }
            
            @media (min-width: 992px){
                background: rgba($color: $color-primary, $alpha: 0.85);
            }
        }

        .row{
            justify-content: center;
            align-items: center;
        }
        
        .container-fluid{
            position: relative;
            z-index: 20;
            width: 100%;
            max-width: 1400px;
            
            @media (min-width: 992px){
                padding: 0 50px;
            }

            h3{
                color: $color-text-tertiary;
                margin-bottom: 20px;
                position: relative;
                z-index: 20;
                text-shadow: 0px 4px 6px rgba(0,0,0,0.3);
                
                @media (max-width: 992px){
                    font-size: 34px;
                    line-height: 36px;
                    text-align: center;
                }
                
                @media (min-width: 576px) and (max-width: 1200px){
                    font-size: 50px;
                    line-height: 52px;
                }

                @media (min-width: 1200px){
                    font-size: 60px;
                    line-height: 62px;
                }
            }

            p{
                color: $color-text-tertiary;
                position: relative;
                z-index: 20;
                text-shadow: 0px 4px 6px rgba(0,0,0,0.3);
                
                @media (max-width: 992px){
                    font-size: 14px;
                    line-height: 18px;
                    text-align: center;
                }
                
                @media (min-width: 992px){
                    font-size: 18px;
                    line-height: 22px;
                }
            }

            .col-img{
                display: flex;

                @media (max-width: 992px){
                    display: none;
                }

                @media (min-width: 992px) and (max-width: 1200px){
                    justify-content: flex-end;
                    height: 320px;
                }
                
                @media (min-width: 1200px){
                    justify-content: flex-end;
                    height: 360px;
                }

                img{
                    width: auto;
                    max-width: none;
                    height: 100%;
                }
            }
        }
    }
</style>

<style>
    .video-home-banner .container-fluid p strong,
    .video-home-banner .container-fluid h3 strong{color: #4aae57;}
</style>